export default __webpack_public_path__ + "static/media/208.ebacf191.gif";